import { logFirebaseEvent } from "./firebaseClient";
import { getVisitor, markVisit } from "./visitor";

const metadata = (visitor) => ({
  ...visitor,
  language: navigator.language,
  screenWidth: window.innerWidth,
  screenHeight: window.innerHeight,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export const logPageVisit = () => {
  const visitor = markVisit();
  return logFirebaseEvent("visits", {
    ...metadata(visitor),
    eventType: "page_visit",
    path: window.location.pathname,
  });
};

export const logResumeClick = () =>
  logFirebaseEvent("resume_clicks", {
    ...metadata(getVisitor()),
    eventType: "resume_click",
    clickedAt: new Date().toISOString(),
  });

export const logWeatherUse = (weather) =>
  logFirebaseEvent("visits", {
    ...metadata(getVisitor()),
    eventType: "weather_loaded",
    condition: weather.condition,
    temperature: weather.temperature,
    timezoneAbbreviation: weather.timezone,
  });
